// removed by extract-text-webpack-plugin
module.exports = {"Emoji":"Emoji__mIMbO","Container":"Container__2YkxO"};


//////////////////
// WEBPACK FOOTER
// ./routes/Chat/Chat/ChatFooter/EmojiContainer/style.scss
// module id = zjtR
// module chunks = 0